import React, { useState, useRef, useEffect } from "react";
import { Checkbox } from "antd";
import downArrow from "../../assets/images/chevron-up-black.svg";
import filterIconDefault from "../../assets/mobile/mobile-filter-icon.svg";

const FilterDropdown = ({
  filters,
  onFiltersChange,
  onApply,
  sortBy,
  iconSrc = filterIconDefault,
  iconAlt = "filter",
  isMobile = false,
}) => {
  const statusOptions = [
    { value: "LIVE", label: "Live" },
    { value: "YET_TO_TRIGGER", label: "Yet to Trigger" },
    { value: "CLOSED_TARGETHIT", label: "Target Hit" },
    { value: "CLOSED_STOPLOSSHIT", label: "Stoploss Hit" },
  ];

  const [isOpen, setIsOpen] = useState(false);
  const [localFilters, setLocalFilters] = useState(filters);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleCheckboxChange = (section, value, checked) => {
    const updatedFilters = {
      ...localFilters,
      [section]: checked
        ? [...localFilters[section], value]
        : localFilters[section].filter((item) => item !== value),
    };

    setLocalFilters(updatedFilters);
    onFiltersChange(updatedFilters);
  };

  const handleApply = () => {
    setIsOpen(false);
    onApply(localFilters);
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="relative inline-block" ref={dropdownRef}>
      <div
        className="flex items-center gap-2 cursor-pointer text-sm font-medium text-[#454545] min-w-[40px] min-h-[40px] justify-center transition-all duration-200 p-2 md:border md:border-brand-border md:py-[5px] md:px-2.5 md:rounded-[5px] md:hover:border-[#1569AB]"
        onClick={toggleDropdown}
      >
        <div className="md:hidden">
          <img src={iconSrc} alt={iconAlt} className="w-5 h-5" />
        </div>
        <div className="hidden md:flex md:items-center md:gap-2">
          <span>FILTERS</span>
          <img
            src={downArrow}
            alt="dropdown arrow"
            className={`w-3 h-3 transition-transform duration-200 ${
              isOpen ? "rotate-180" : ""
            }`}
          />
        </div>
      </div>

      {isOpen && (
        <>
          <div
            className="fixed inset-0 bg-black bg-opacity-40 z-[998] md:hidden"
            onClick={toggleDropdown}
          ></div>
          <div className="fixed top-0 left-0 right-0 w-full mt-0 rounded-none z-[999] max-h-[80vh] overflow-y-auto bg-white border border-brand-border text-[#454545] shadow-[0_4px_12px_rgba(0,0,0,0.15)] md:absolute md:top-full md:right-0 md:mt-1 md:w-[450px] md:lg:w-[500px] md:max-w-[500px] md:rounded-md md:z-[1000] md:h-auto md:max-h-none md:pb-0">
            <div className="text-gray-400 pt-3.5 pb-3.5 pl-3.5 font-semibold text-base border-b border-brand-border font-roboto">
              FILTERS
            </div>
            <div className="p-4 border-b border-[#ebebeb]">
              <div className="text-base font-semibold font-roboto text-[#454545] mb-3">
                Status
              </div>
              <div className="flex font-roboto overflow-hidden text-[#454545] flex-col gap-3 py-2 md:flex-row md:gap-2 md:py-0">
                {statusOptions.map((option) => (
                  <Checkbox
                    key={option.value}
                    checked={localFilters.status.includes(option.value)}
                    onChange={(e) =>
                      handleCheckboxChange(
                        "status",
                        option.value,
                        e.target.checked
                      )
                    }
                  >
                    {option.label}
                  </Checkbox>
                ))}
              </div>
            </div>

            {/* <div className="p-4 border-b border-[#ebebeb]">
            <div className="text-base font-semibold font-roboto text-[#454545] mb-3">Combination of Trades</div>
            <div className="flex font-roboto overflow-hidden text-[#454545] flex-col gap-3 py-2 md:flex-row md:gap-2 md:py-0">
              <Checkbox
                checked={localFilters.combination.includes("Single")}
                onChange={(e) =>
                  handleCheckboxChange(
                    "combination",
                    "Single",
                    e.target.checked
                  )
                }
              >
                Single
              </Checkbox>
              <Checkbox
                checked={localFilters.combination.includes("Multiple (Hedge)")}
                onChange={(e) =>
                  handleCheckboxChange(
                    "combination",
                    "Multiple (Hedge)",
                    e.target.checked
                  )
                }
              >
                Multiple (Hedge)
              </Checkbox>
            </div>
          </div> */}

            <div className="p-4 border-b border-[#ebebeb] last:border-b-0">
              <div className="text-base font-semibold font-roboto text-[#454545] mb-3">
                Segment
              </div>
              <div className="flex font-roboto overflow-hidden text-[#454545] flex-col gap-3 py-2 md:flex-row md:gap-2 md:py-0">
                <Checkbox
                  checked={localFilters.segment.includes("Equity")}
                  onChange={(e) =>
                    handleCheckboxChange("segment", "Equity", e.target.checked)
                  }
                >
                  Equity
                </Checkbox>
                <Checkbox
                  checked={localFilters.segment.includes("Stock Futures")}
                  onChange={(e) =>
                    handleCheckboxChange(
                      "segment",
                      "Stock Futures",
                      e.target.checked
                    )
                  }
                >
                  Stock Futures
                </Checkbox>
                <Checkbox
                  checked={localFilters.segment.includes("Index Options")}
                  onChange={(e) =>
                    handleCheckboxChange(
                      "segment",
                      "Index Options",
                      e.target.checked
                    )
                  }
                >
                  Index Options
                </Checkbox>
                <Checkbox
                  checked={localFilters.segment.includes("Stock Options")}
                  onChange={(e) =>
                    handleCheckboxChange(
                      "segment",
                      "Stock Options",
                      e.target.checked
                    )
                  }
                >
                  Stock Options
                </Checkbox>
              </div>
            </div>

            <div className="flex justify-center">
              <button
                className="bg-primary text-white border-none rounded-b-lg py-4 px-4 text-base font-medium cursor-pointer transition-colors duration-200 w-full hover:bg-primary active:bg-primary"
                onClick={handleApply}
              >
                Apply
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default FilterDropdown;
